

















import Vue from 'vue';
import Component from 'vue-class-component';
import {
  mdbNavbar, mdbNavItem, mdbNavbarNav, mdbNavbarToggler, mdbNavbarBrand,
} from 'mdbvue';

@Component({
  name: 'Navbar',
  components: {
    mdbNavbar,
    mdbNavItem,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbNavbarBrand,
  },
})

export default class Navbar extends Vue {}
